import { Flex } from 'components/layout';
import { ScheduledDrive } from 'components/scheduling/ScheduledDrive';
import { SchedulingDrive } from 'components/scheduling/SchedulingDrive';
import { SchedulingDriveCalendly } from 'components/scheduling/SchedulingDriveCalendly';
import { useMainProviderContext } from 'context/main/provider';
import React from 'react';
import { CALENDAR_PLATFORM, CALENDAR_VIEW, PlaybackData } from 'types';

interface IProps {
  view: CALENDAR_VIEW;
  setView: (view: CALENDAR_VIEW) => void;
  setPlaybackData: React.Dispatch<
    React.SetStateAction<PlaybackData | undefined>
  >;
}

export const SchedulingViews = ({ view, setView, setPlaybackData }: IProps) => {
  const { response } = useMainProviderContext();
  const isScheduling = view === CALENDAR_VIEW.SCHEDULING;
  const calendar = response.calendar;
  const platform = calendar?.platform;

  return (
    <Flex>
      {isScheduling && calendar && (
        <Flex padding='20px 0'>
          {(platform === CALENDAR_PLATFORM.GOOGLE ||
            platform === CALENDAR_PLATFORM.OUTLOOK) && (
            <SchedulingDrive
              orderDetails={response}
              onChangeView={setView}
              setOrderDetails={setPlaybackData}
              inventoryItem={response.inventoryItem}
              // check if this is correct
              mainColor={response.playerDesign?.playerBackgroundColor}
              mainTextColor={response.playerDesign?.playerIconsAndTextColor}
            />
          )}
          {platform === CALENDAR_PLATFORM.CALENLDY && (
            <SchedulingDriveCalendly
              orderDetails={response}
              onChangeView={setView}
              inventoryItem={response.inventoryItem}
            />
          )}
        </Flex>
      )}
      {view === CALENDAR_VIEW.SCHEDULED && (
        <ScheduledDrive orderDetails={response} item={response.inventoryItem} />
      )}
    </Flex>
  );
};
